import React from 'react';
import sIcon1 from '../../images/moneytransfer/aboutus/icons8-pound-60.png'
import sIcon2 from '../../images/moneytransfer/aboutus/icons8-secure-48.png'
import sIcon3 from '../../images/moneytransfer/aboutus/icons8-around-the-globe-64.png'
import sIcon4 from '../../images/moneytransfer/aboutus/icons8-no-money-64.png'

const FeaturesSection = (props) => {
    return (
        <section className="fanfact pt-20 pb-125">
            <div className="container">
                <div className="ap-feature_wrap">
                    <div className="row mt-none-30">
                        <div className="col-lg-3 col-md-6 mt-30">
                            <div className="ap-feature-item wow fadeInUp" data-wow-delay="0ms" data-wow-duration="600ms">
                                <div className="xb-item--icon"><img src={sIcon1} className='aboutus-icons' alt="Fast Transfers" /></div>
                                <h4 className="xb-item--title">Instant Transfers</h4>
                                <p className="xb-item--content">Send money globally within minutes. Fast, reliable, and always on time.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mt-30">
                            <div className="ap-feature-item wow fadeInUp" data-wow-delay="100ms" data-wow-duration="600ms">
                                <div className="xb-item--icon"><img src={sIcon2} className='aboutus-icons' alt="Secure" /></div>
                                <h4 className="xb-item--title">Secure & Trusted</h4>
                                <p className="xb-item--content">Your transfers are protected with advanced encryption and fraud detection.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mt-30">
                            <div className="ap-feature-item wow fadeInUp" data-wow-delay="200ms" data-wow-duration="600ms">
                                <div className="xb-item--icon"><img src={sIcon3} className='aboutus-icons' alt="Global Access" /></div>
                                <h4 className="xb-item--title">Global Coverage</h4>
                                <p className="xb-item--content">Send money to over 100+ countries with ease and local payout options.</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mt-30">
                            <div className="ap-feature-item wow fadeInUp" data-wow-delay="300ms" data-wow-duration="600ms">
                                <div className="xb-item--icon"><img src={sIcon4} className='aboutus-icons' alt="Transparent Fees" /></div>
                                <h4 className="xb-item--title">ZERO Fees</h4>
                                <p className="xb-item--content">Zero fees on all charges. Know exactly what you pay and what your recipient gets.</p>
                            </div>
                        </div>
                    </div>
                    <p>
                        
                    </p>
                </div>
            </div>
        </section>
    );
}

export default FeaturesSection;
